import Column from '@amzn/meridian/column';
import React, { FC, useMemo, useState } from 'react';
import { DetailedClaim, IAsynchronouslyLoadedValue, OfflinePromotion, ResellerItem } from '../../redux/types';
import { useTranslation } from '../blocks';
import { ClaimLineItemList } from './ClaimLineItemList';
import { ColumnFilter } from './ColumnFilter';

type PromotionalClaimItemListProps = {
    claimDetails: DetailedClaim;
    itemMap: Map<string, ResellerItem>;
    promotionMap: Map<string, OfflinePromotion> | undefined;
    asinToImageUrls: IAsynchronouslyLoadedValue<Map<string, string>>;
};

export const PromotionalClaimItemList: FC<PromotionalClaimItemListProps> = ({
    claimDetails,
    itemMap,
    promotionMap,
    asinToImageUrls,
}) => {
    const { t } = useTranslation('claimDetails');

    const [selectedPromotionIds, setSelectedPromotionIds] = useState<string[]>([]);

    const filteredLineItems = useMemo(() => {
        if (selectedPromotionIds.length === 0) {
            return claimDetails.claimLineItems;
        }
        return claimDetails.claimLineItems.filter((item) => selectedPromotionIds.includes(item.promotionId));
    }, [claimDetails.claimLineItems, selectedPromotionIds]);

    const promotionOptions = useMemo(() => {
        return claimDetails.promotionClaims.map((p) => p.promotionId);
    }, [claimDetails.promotionClaims]);

    return (
        <>
            <Column spacingInset={'medium'}>
                <ClaimLineItemList
                    claimDetails={claimDetails}
                    itemMap={itemMap}
                    isPromotional={true}
                    promotionMap={promotionMap}
                    filteredData={filteredLineItems}
                    asinToImageUrls={asinToImageUrls}
                >
                    {claimDetails.promotionClaims.length > 1 && (
                        <ColumnFilter
                            label={t('filterByPromotion-columnFilterPlaceholder')}
                            values={promotionOptions}
                            value={selectedPromotionIds}
                            onChange={setSelectedPromotionIds}
                        />
                    )}
                </ClaimLineItemList>
            </Column>
        </>
    );
};
